export function decimalDisplay(value: string|null, currency: string|null) {
  if(value===null||!currency||!/^[-+]?\d+(\.\d+)?$/.test(value)) return '—';
  const negative=value.startsWith('-');const raw=value.replace(/^[-+]/,'');
  const precision=new Intl.NumberFormat('zh-CN',{style:'currency',currency}).resolvedOptions().maximumFractionDigits ?? 2;
  const [whole,fraction='']=raw.split('.');let minor=BigInt(whole+fraction.padEnd(precision,'0').slice(0,precision));
  if(Number(fraction[precision]||'0')>=5) minor++;
  const digits=minor.toString().padStart(precision+1,'0');
  const result=precision ? digits.slice(0,-precision)+'.'+digits.slice(-precision) : digits;
  return `${minor===0n?'':negative?'-':'+'}${result} ${currency}`;
}
